var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44C0 68.3005 19.6995 88 44 88ZM37.1093 52.2222L62.7048 29.5063C64.422 28.0558 66.873 28.3501 68.1078 30.1868C69.2884 31.943 68.899 34.4472 67.2724 35.8207L39.7204 60.2751C39.4502 60.5033 39.1572 60.6922 38.8657 60.8295C38.4366 61.0416 37.9707 61.1636 37.4337 61.1911L37.0844 61.1895C36.6195 61.1643 36.1657 61.0479 35.7586 60.8512C35.5387 60.7482 35.3339 60.6299 35.1136 60.4742L22.5258 51.0402C20.8788 49.649 20.4894 47.1448 21.67 45.3885C22.8007 43.7066 24.9783 43.2989 26.7324 44.4513L37.1093 52.2222Z",
    fill: "#1B8367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.503ee0310f8505fee187940a2b9efb87.svg";
export { ForwardRef as ReactComponent };